export const inputSchema = {
    giantSlalom: {
        new: {
            keyup: ['arrowup', 'w'],
            keydown: ['arrowdown', 's'],
            keyleft: ['arrowleft', 'a'],
            keyright: ['arrowright', 'd'],
            keyaction: [' '],
            keyaction2: ['shift'],
            keyexit: ['escape']
        },
        old: {
            keyup: [38, 87],
            keydown: [40, 83],
            keyleft: [37, 65],
            keyright: [39, 68],
            keyaction: [32],
            keyaction2: [16],
            keyexit: [27]
        }
    },
    biathlon: {
        new: {
            keyup: ['arrowup', 'w'],
            keydown: ['arrowdown', 's'],
            keyleft: ['arrowleft', 'a'],
            keyright: ['arrowright', 'd'],
            keyaction: [' '],
            keyaction2: ['q'],
            keyaction3: ['e'],
            keyexit: ['escape']
        },
        old: {
            keyup: [38, 87],
            keydown: [40, 83],
            keyleft: [37, 65],
            keyright: [39, 68],
            keyaction: [32],
            keyaction2: [81],
            keyaction3: [69],
            keyexit: [27]
        }
    },
    default: {
        new: {
            keyup: ['arrowup', 'w'],
            keydown: ['arrowdown', 's'],
            keyleft: ['arrowleft', 'a'],
            keyright: ['arrowright', 'd'],
            keyaction: ['enter', ' '],
            keyexit: ['escape']
        },
        old: {
            keyup: [38, 87],
            keydown: [40, 83],
            keyleft: [37, 65],
            keyright: [39, 68],
            keyaction: [13, 32],
            keyexit: [27]
        }
    }
};
//# sourceMappingURL=index.js.map